import {Template} from "./template.js";
import { Left_menu } from './left_menu/component.js'
import { Form_window } from './form_window/component.js'

const Page4_addmodem = {
    name: 'Page4_addmodem',
    components:{
        'left-menu': Left_menu,
        'form-window': Form_window
    },
    template: Template,
    data: function(){
        return{
            tubes:[],
            phones:[],
            selected_phones:[]
        }
    },

    created() {
		var cont = this;
		// Первый запуск 
        this.getTubes();
        this.getPhones();
	},

    methods:{

        getTubes() {
			var cont = this;
			//запускаем аякс из плагина
			this.$API('static_data', 'tubes', {},
				function(data) {
                    cont.tubes=data;
					},
					function(errorText) { console.log(errorText) });
        },

        getPhones(){
            var cont = this;
			this.$API('static_data', 'phones', {},
            function(data) {
                for (let key in data){
                    cont.phones.push({
                        text: data[key].name+' \t \t \t '+data[key].phone+'\t', 
                        value: data[key].phone,
                        checked: data[key].status==1 ? true : false
                    });

                    if(data[key].status==1){
                        cont.selected_phones.push(''+data[key].phone+'');
                    }
                }
            },
            function(errorText) { console.log(errorText) }); 
        },

        get_coordinates(coordinates){
            let regEx=/\d+[\.,]?\d*/g;
            let coord_array=[];
            //если в координаты ничего не записано, возвращаем как есть
            if(coordinates==''){
                return coordinates;
            }
                //из полученной строки получаем массив чисел,
            //с помощью регулярки + меняем запятые на точки при парсинге
            else{
                coord_array=coordinates.match(regEx).map((coordinate) => {return parseFloat(coordinate.replace(',','.'))});
                if (coord_array.length==2){
                    return JSON.stringify({ "type":"Point", "coordinates": coord_array });
                }
                else{
                    let j=0;
                    let tube_coords=[];
                    for(let i=0; i<coord_array.length; i++){
                        tube_coords[j]=[];
                        tube_coords[j][0]=coord_array[i++];
                        tube_coords[j][1]=coord_array[i];
                        j++;
                    }
                    return JSON.stringify({ "type":"LineString", "coordinates": tube_coords });
                }
            }
        },
    }
}
export { Page4_addmodem }


// WEBPACK FOOTER //
// ./src/app/js/components/page4_addmodem/component.js